export const SET_PER_PACKET = 250;
export const MAG_PER_PACKET = 40;

export const KKP_DISTRIB_PALETTE = [
  { key: 'bleu', label: 'Bleu', hex: '#C9DAF8', cible: 'nom' },
  { key: 'vert', label: 'Vert', hex: '#D9EAD3', cible: 'nom' },
  { key: 'jaune', label: 'Jaune', hex: '#FFF2CC', cible: 'commentaire' },
  { key: 'rouge', label: 'Rouge', hex: '#F4CCCC', cible: 'commentaire' },
];

export const KKP_DISTRIB_MOIS = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' },
];

export const KKP_DISTRIB_ZONES = [
  { key: 'int', label: 'INT', livreur: 'Denis' },
  { key: 'ext', label: 'EXT', livreur: 'Philippe' },
  { key: 'morvan', label: 'Morvan', livreur: 'Denis' },
];

export function distribCouleurHex(key) {
  return KKP_DISTRIB_PALETTE.find((c) => c.key === key)?.hex ?? null;
}

export function distribCouleurCible(key) {
  return KKP_DISTRIB_PALETTE.find((c) => c.key === key)?.cible ?? null;
}

export function magPackets(qty, perPacket = MAG_PER_PACKET) {
  const n = Number(qty) || 0;
  if (n <= 0) return 0;
  return Math.ceil(n / perPacket);
}

export function setPieces(paquets, perPacket = SET_PER_PACKET) {
  const n = Number(paquets) || 0;
  if (n <= 0) return 0;
  return n * perPacket;
}

export function formatDistribPhone(tel) {
  if (!tel) return '';
  const digits = String(tel).replace(/\D/g, '');
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  }
  return tel;
}

export function formatMoisList(mois = []) {
  return mois
    .map((m) => KKP_DISTRIB_MOIS.find((item) => item.value === Number(m))?.label)
    .filter(Boolean)
    .join(', ');
}
